export const masterManagementMenuDef = [
    {
        "name": "menu.corporate_master",
        "resource": "corporate_master",
        "icon": "fa fa-tag",
        "url": "corporate_master",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "corporate_master"
    },
    {
        "name": "menu.common_master",
        "resource": "common_master",
        "icon": "fa fa-tag",
        "url": "common_master",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "common_master"
    },
    {
        "name": "menu.cug_location_mapping",
        "resource": "cug_location_mapping",
        "icon": "fa fa-tag",
        "url": "cug_location_mapping",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "cug_location_mapping"
    },
    {
        "name": "menu.benefit_group",
        "resource": "benefit_group",
        "icon": "fa fa-tag",
        "url": "benefit_group",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "benefit_group"
    },
    {
        "name": "menu.benefit_plan",
        "resource": "benefit_plan",
        "icon": "fa fa-tag",
        "url": "benefit_plan",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "benefit_plan"
    },
    {
        "name": "menu.bg_bp_mapping",
        "resource": "bg_bp_mapping",
        "icon": "fa fa-tag",
        "url": "bg_bp_mapping",
        "auto_crud": true,
        "showMenu": true,
        "breadcrumb": "bg_bp_mapping"
    }
]